import React, { Component } from 'react';
import FormField from './FormField/FormField';
import { connect } from 'react-redux';
import { changeLoginStatus } from '../../actions/index';
import { sendTestTicketsToExpert } from '../../api/tickets';
import { changeTab } from '../../actions/creatorsSync';
import environment from '../../environment';
import Tooltip from 'rc-tooltip';
import {
  Container,
  Holder,
  HaveAccountContainer,
  FormContainer,
  Title,
  ServerError,
  RegistrationButton,
  ServerErrorMessage,
  InfoIcon,
  FormItem,
} from './SignUpExpert.styles';
import { configure, handleError } from 'services/ErrorService/ErrorService';
import SimplrLogo from '../common/SimplrLogo';
import { electricBlue } from '../common/colorConstants';
import { SimplrLogoWrapper } from '../AuthLayout/Old/AuthLayout.styles';
import * as SessionAnalyticsService from 'services/SessionAnalyticsService/SessionAnalyticsService';
import { ResetLink } from '../LoginPage/LoginPage.styles';
import { PhoneInputField } from './PhoneInputField/PhoneInputField';
import { isValidPhoneNumber } from 'react-phone-number-input';
import makeRequest from '../../api/makeRequest';
import AuthService from 'services/authService';
import * as SimplrErrors from '@asurion-core/typescript-utils/SimplrErrors';
const SimplrPassword = require('@asurion-core/typescript-utils/SimplrPassword');

const simplrPasswordValidator = new SimplrPassword.SimplrADPasswordValidator();

class SignUpExpert extends Component {
  state = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    password: '',
    passwordVerify: '',
    errors: {},
    done: false,
    token: '',
  };

  async UNSAFE_componentWillMount() {
    // if user is logged in when landing on signup log them out
    if (AuthService.current()) {
      await AuthService.logout();
    }
  }

  componentDidMount() {
    let url = window.location.href;
    this.setState({ token: url.split('token=')[1] });
  }

  signUpExpert = async () => {
    let user = {};
    user.firstName = this.state.firstName;
    user.lastName = this.state.lastName;
    user.expertPhone = this.state.phoneNumber;
    user.username = this.state.email;
    user.email = this.state.email;
    user.password = this.state.password;
    user.token = this.state.token;

    try {
      const URL = `${environment.services.authServiceUrl}/v1/createExpertAccount`;
      const { result: response } = await makeRequest(URL, {
        method: 'POST',
        data: user,
      });

      await AuthService.login(response.sessionToken);
      this.props.changeLoginStatus(true);

      // Auto send test tickets to NEW experts on signup only
      await sendTestTicketsToExpert(response.simplrExpertObjId);

      /** NOTE(apoorvyadav1|SPD-13362|2025-10-15):
       * Previously, FullStory was initialized when the website loaded, which is not ideal for privacy compliance.
       * Initialize FullStory if user is logged in and it's not already initialized
       */
      SessionAnalyticsService.initializeSessionAnalyticsServices();

      SessionAnalyticsService.identify(response.userId, {
        name: this.state.firstName + ' ' + this.state.lastName,
        email: this.state.email,
        inviteToken: this.state.token,
      });

      SessionAnalyticsService.event('Registered', {
        inviteToken: this.state.token,
      });

      configure((scope) => {
        scope.setUser({
          name: this.state.firstName + ' ' + this.state.lastName,
          id: response.simplrExpertObjId,
          email: this.state.email,
          username: this.state.email,
        });
        // don't create specialists via this flow
        scope.setExtra('isAdmin', false);
      });

      if (window.Intercom) {
        window.Intercom('update', {
          app_id: environment.intercom.intercomId,
          name: this.state.firstName + ' ' + this.state.lastName,
          email: this.state.email,
          user_id: response.simplrExpertObjId,
        });
      }

      // force a refresh when changing the URL so the user loader runs again
      window.location.href = '/home';
    } catch (error) {
      handleError({ error });
      // not displaying this error to the user but keeping as is in case we want to display in the future.
      let errors;

      if (error.response?.code === SimplrErrors.Codes.WEAK_PASSWORD) {
        errors = {
          password: error.response.fieldErrors[0],
        };
      } else if (typeof error?.message === 'string') {
        errors = { serverError: error.message };
      } else {
        errors = { serverError: 'Login failed' };
      }

      this.setState({ errors });
    }
  };

  setValue = (e, field) => {
    e.preventDefault();
    this.setState({ [field]: e.target.value });
  };

  runChecks = () => {
    const errors = {};
    this.setState({ errors: {} });
    // first name
    if (this.state.firstName.length === 0) {
      errors.firstName = 'Please enter a first name';
    }
    // last name
    if (this.state.lastName.length === 0) {
      errors.lastName = 'Please enter a last name';
    }
    // email
    if (!/\S+@\S+\.\S+/.test(this.state.email)) {
      errors.email = 'Please enter a valid email address';
    }
    // phoneNumber
    if (!this.state.phoneNumber || this.state.phoneNumber.length === 0) {
      errors.phoneNumber = 'Please enter a phone number';
    } else if (!isValidPhoneNumber(this.state.phoneNumber)) {
      errors.phoneNumber =
        'Please enter a valid phone number with country code (up to 15 digits in the correct format)';
    }

    // password
    const passwordValidation = simplrPasswordValidator.validate(this.state.password, this.state.email);

    if (passwordValidation.status !== SimplrPassword.types.PasswordValidationStatus.VALID) {
      errors.password = passwordValidation.errors[0].message;
    }

    if (this.state.password !== this.state.passwordVerify) {
      errors.passwordVerify = 'Passwords should match';
    }

    this.setState({ errors });

    if (Object.keys(errors).length === 0) {
      this.setState({ done: true });
      this.signUpExpert();
    }
  };

  render() {
    return (
      <Container>
        <Holder>
          <FormContainer>
            <SimplrLogoWrapper>
              <SimplrLogo color={electricBlue} />
            </SimplrLogoWrapper>
            <Title>Let's get started</Title>
            <FormItem>
              <FormField
                error={this.state.errors}
                setValue={this.setValue}
                value={this.state.firstName}
                field="firstName"
                placeholder="First Name"
                inputType="text"
              />
            </FormItem>
            <FormItem>
              <FormField
                error={this.state.errors}
                setValue={this.setValue}
                value={this.state.lastName}
                field="lastName"
                placeholder="Last Name"
                inputType="text"
              />
            </FormItem>
            <FormItem>
              <FormField
                error={this.state.errors}
                setValue={this.setValue}
                field="email"
                value={this.state.email}
                placeholder="Email"
                inputType="text"
              />
            </FormItem>
            <FormItem>
              <PhoneInputField
                value={this.state.phoneNumber}
                onChange={(value) => this.setState({ phoneNumber: value })}
                error={this.state.errors.phoneNumber}
              />
              <Tooltip
                placement="bottom"
                overlay={'Please enter your phone number in the format +12345678901'}
                arrowContent={<div className="rc-tooltip-arrow-inner" />}
              >
                <InfoIcon
                  src="/images/info_icon.svg"
                  alt="info-icon"
                  phoneNumberError={this.state.errors.phoneNumber}
                />
              </Tooltip>
            </FormItem>
            <FormItem>
              <FormField
                error={this.state.errors}
                setValue={this.setValue}
                field="password"
                value={this.state.password}
                placeholder="Password"
                inputType="password"
              />
              <Tooltip
                placement="bottom"
                overlay={'10 characters | 1 uppercase | 1 lowercase | 1 digit'}
                arrowContent={<div className="rc-tooltip-arrow-inner" />}
              >
                <InfoIcon
                  src="/images/info_icon.svg"
                  alt="info-icon"
                  passwordError={this.state.errors.password}
                  passwordVerifyError={this.state.errors.passwordVerify}
                />
              </Tooltip>
            </FormItem>
            <FormItem>
              <FormField
                error={this.state.errors}
                setValue={this.setValue}
                field="passwordVerify"
                value={this.state.passwordVerify}
                placeholder="Re-type password"
                inputType="password"
              />
            </FormItem>
            <HaveAccountContainer>
              Already have an account?&nbsp;&nbsp;
              <ResetLink to="/login">Log in now!</ResetLink>
            </HaveAccountContainer>
          </FormContainer>
          <ServerErrorMessage hide={!this.state.errors.serverError}>
            <ServerError>{this.state.errors.serverError}</ServerError>
          </ServerErrorMessage>
          <RegistrationButton onClick={this.runChecks}>Sign up</RegistrationButton>
        </Holder>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeLoginStatus: (isLoggedIn) => dispatch(changeLoginStatus(isLoggedIn)),
    changeTab: (tabName) => dispatch(changeTab(tabName)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpExpert);
